import { useMemo } from 'react';

import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';

import { GradingGridRow } from './types';

export interface GradingGridProps {
  rowData: GradingGridRow[];
  storageKey: string;
  onCellValueChanged?: (updatedData: GradingGridRow[]) => void;
  height?: string;
  width?: string;
}

const gradingGridColumnDefs: ColDef[] = [
  { field: 'grade', headerName: '', width: 30, editable: false },
  { field: 's9', headerName: '9', width: 50, editable: true },
  { field: 's8', headerName: '8', width: 50, editable: true },
  { field: 's7', headerName: '7', width: 50, editable: true },
  { field: 's6', headerName: '6', width: 50, editable: true },
  { field: 's5', headerName: '5', width: 50, editable: true },
  { field: 's4', headerName: '4', width: 50, editable: true },
  {
    field: 'total',
    headerName: 'Total',
    width: 70,
    editable: false,
    valueGetter: (params: any) => {
      const data = params.data;
      return (
        (Number(data.s4) || 0) +
        (Number(data.s5) || 0) +
        (Number(data.s6) || 0) +
        (Number(data.s7) || 0) +
        (Number(data.s8) || 0) +
        (Number(data.s9) || 0)
      );
    },
  },
];

export const GradingGrid = ({
  rowData,
  storageKey,
  onCellValueChanged,
  height = '120px',
  width = '33rem',
}: GradingGridProps) => {
  const memoizedColumnDefs = useMemo(() => gradingGridColumnDefs, []);
  const defaultGridOptions = useDefaultGridOptions();

  const handleCellValueChanged = (params: any) => {
    const updatedData = rowData.map((row) =>
      row.grade === params.data.grade
        ? { ...row, [params.column.getId()]: params.newValue }
        : row,
    );
    onCellValueChanged?.(updatedData);
  };

  return (
    <div style={{ height, width }}>
      <WithLocalStorage storageKey={storageKey}>
        <AgGridReact
          gridOptions={defaultGridOptions}
          className="ag-theme-transova"
          defaultColDef={{
            resizable: true,
            sortable: false,
            filter: false,
            cellStyle: { textAlign: 'center' },
          }}
          columnDefs={memoizedColumnDefs}
          rowData={rowData}
          domLayout="normal"
          onCellValueChanged={handleCellValueChanged}
        />
      </WithLocalStorage>
    </div>
  );
};
